<template>
  <div class="text-center">
    <v-pagination
      v-model="page"
      :length="paginationLength"
      :total-visible="7"
    ></v-pagination>
  </div>
</template>

<script>

export default {
  name: 'Pagination',
  components: {
  },
  data() {
    return {
      page: 1,
    };
  },
  props: {
    paginationLength: Number,
  },
  watch: {
    page(newPage) {
      this.sendRequest(newPage);
    },
  },
  methods: {
    sendRequest(page) {
      this.$emit('getVersionsPerPage', page);
    },
  },
};
</script>

<style scoped>

</style>
